import React from 'react';
import {Link} from 'react-router-dom';
import {useResourceCreationLock} from './TrialLock';
import '../styles/PaidInstanceLaunch.scss';

// Do not mount the paid launch form (or fetch its catalogue) until billing is known.
// The backend independently authorizes every provisioning request.
const PaidInstanceLaunch: React.FC<{children: React.ReactElement}> = ({children}) => {
    const locked = useResourceCreationLock(false, true);
    if (locked) {
        return <section className="paid-access" aria-label="Paid instance access">
            <h1>Paid resources</h1>
            <p role="status">{locked}</p>
            <div className="paid-access__links">
                <Link to="/category/user/billing?setup-billing=1">Open billing</Link>
                <Link to="/mcp">Free VMs via MCP</Link>
            </div>
        </section>;
    }
    return children;
};
export default PaidInstanceLaunch;
